import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  static values = { 
    content: String,
    visible: Boolean
  }

  connect() {
    // Globaler Popover-Controller verbunden
    this.element.addEventListener('global-popover:show', this.handleShow.bind(this))
    this.element.addEventListener('global-popover:hide', this.handleHide.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('global-popover:show', this.handleShow.bind(this))
    this.element.removeEventListener('global-popover:hide', this.handleHide.bind(this))
  }

  handleShow(event) {
    this.show(event.detail.content)
  }

  handleHide(event) {
    this.hide()
  }

  // Zeigt die Sidebar mit dem gegebenen Inhalt
  show(content) {
    if (this.hasContentTarget) {
      this.contentTarget.innerHTML = content
      this.element.classList.remove('translate-x-full')
      this.element.classList.add('translate-x-0')
      this.visibleValue = true
    }
  }

  // Versteckt die Sidebar
  hide() {
    this.element.classList.remove('translate-x-0')
    this.element.classList.add('translate-x-full')
    this.visibleValue = false
  }

  // Toggle das Popover
  toggle(content) {
    if (this.visibleValue) {
      this.hide()
    } else {
      this.show(content)
    }
  }

  // Setzt den Inhalt des Popovers
  setContent(content) {
    if (this.hasContentTarget) {
      this.contentTarget.innerHTML = content
    }
  }

  // Prüft ob das Popover sichtbar ist
  isVisible() {
    return this.visibleValue
  }
}
